export default __webpack_public_path__ + "static/media/cpp.0f7ca278.svg";